type ListWorkflowsParams = {
  includeArchived?: boolean
  state?: unknown[]
  workflowType?: unknown
  workflowTypes?: unknown[]
}

export const workflowQueryKeys = {
  all: ['workflows'] as const,
  lists: () => [...workflowQueryKeys.all, 'list'] as const,
  list: (params: ListWorkflowsParams) => [...workflowQueryKeys.lists(), params] as const,
  details: () => [...workflowQueryKeys.all, 'detail'] as const,
  detail: (workflowId: string) => [...workflowQueryKeys.details(), workflowId] as const,
  conditionGroups: (workflowId: string) => [...workflowQueryKeys.detail(workflowId), 'condition-groups'] as const,
}
